<template>
    <section class="section">
        <div class="container is-max-widescreen is-max-desktop">
            <h1 class="title has-text-centered">
                Tableau financeur pour 2026
            </h1>


            <div class="columns">

                <div class="column is-one-third">
                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title">
                                Total 2026 en subvention
                            </p>
                        </header>
                        <div class="card-content">
                            <div class="content">
                                <span class="title h1">{{ totalSub }} €</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="column is-one-third">
                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title">
                                Total 2026 en prestation
                            </p>
                        </header>
                        <div class="card-content">
                            <div class="content">
                                <span class="title h1">{{ totalPresta }} €</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="column is-one-third">
                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title">
                                Total 2026
                            </p>
                        </header>
                        <div class="card-content">
                            <div class="content">
                                <span class="title h1">{{ totalTotal }} €</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <hr>

            <hr>

            <b-field grouped>

                <b-field label="Filtre rapide sur les partenaires">
                    <b-input type="text"
                             v-model="filterP"
                             @input="searchP()">
                    </b-input>
                </b-field>

                <b-field label="Filtre rapide sur les projets">
                    <b-input type="text"
                             v-model="filterR"
                             @input="searchR()">
                    </b-input>
                </b-field>

                <!--
                <b-field label="Dossier">
                    <b-select
                        placeholder="Dossiers"
                        @input="filterByFolder">
                        <option value="all">Tout</option>
                        <option
                            v-for="dossier in folders"
                            :value="dossier"
                            :key="dossier">
                            {{ dossier }}
                        </option>
                    </b-select>
                </b-field>
                -->

                <b-field label="Arrondir">
                    <b-switch v-model="isRounded">
                        Arrondir les valeurs
                    </b-switch>
                </b-field>

            </b-field>


            <b-field grouped
                     group-multiline
                     label="Cocher les colonnes à afficher">
                <div v-for="(column, index) in columnsVisible"
                     :key="index"
                     class="control">
                    <b-checkbox v-model="column.display">
                        {{ column.title }}
                    </b-checkbox>
                </div>
            </b-field>

            <hr>

            <b-table
                :data="data"
                ref="table"
                detailed
                hoverable
                striped
                paginated
                per-page="15"
                custom-detail-row
                detail-key="financeurs"
                show-detail-icon>

                <b-table-column
                    field="financeurs"
                    label="Projets et phases"
                    sortable
                    v-slot="props">

                    <span
                        class="pointer"
                        @click.prevent="getDetailFinanceur(props.row)">
                        <b-icon
                            pack="fas"
                            icon="tachometer-alt"
                            size="is-small">
                    </b-icon> &nbsp; <b>{{ props.row.financeurs }}</b>
                    </span>

                </b-table-column>

                <b-table-column
                    field="sumsSub"
                    :visible="columnsVisible['totalsub'].display"
                    :label="columnsVisible['totalsub'].title"
                    v-slot="props">
                    <b>{{
                            isRounded ? addSpace(roundTwoDigits(props.row.sumsSub, 2)) : addSpace(props.row.sumsSub)
                        }}</b>
                </b-table-column>

                <b-table-column
                    field="sumsPresta"
                    :visible="columnsVisible['totalpresta'].display"
                    :label="columnsVisible['totalpresta'].title"
                    v-slot="props">
                    <b>{{
                            isRounded ? addSpace(roundTwoDigits(props.row.sumsPresta, 2)) : addSpace(props.row.sumsPresta)
                        }}</b>
                </b-table-column>

                <b-table-column
                    field="sums"
                    :visible="columnsVisible['total'].display"
                    :label="columnsVisible['total'].title"
                    v-slot="props">
                    <b>{{ isRounded ? addSpace(roundTwoDigits(props.row.sums, 2)) : addSpace(props.row.sums) }}</b>
                </b-table-column>

                <b-table-column
                    field="total"
                    :visible="columnsVisible['totalProjet'].display"
                    :label="columnsVisible['totalProjet'].title"
                    >
                    -
                </b-table-column>

                <b-table-column
                    field="maxallouable"
                    :visible="columnsVisible['maxallouable'].display"
                    :label="columnsVisible['maxallouable'].title"
                    v-slot="props">
                <span :class="
                                        [
                                            'tag',
                                            {'is-success': props.row.maxallouable > props.row.sums || props.row.maxallouable === -1},
                                            {'is-danger': props.row.maxallouable < props.row.sums && props.row.maxallouable !== -1},
                                        ]
                                        ">
                    <b>
                    {{ isRounded ? addSpace(roundTwoDigits(props.row.sums, 2)) : addSpace(props.row.sums) }} €
                    sur
                    {{ props.row.maxallouable === -1 ? '∞' : addSpace(roundTwoDigits(props.row.maxallouable)) }} €
                    </b>
                </span>
                </b-table-column>

                <template slot="detail" slot-scope="props">
                    <tr v-for="item in props.row.details" :key="item.project">

                        <td></td>

                        <td class="has-text-centered pointer"
                            @click.prevent="getDetailProject(item.project)">
                            {{ item.project }}
                        </td>


                        <td v-show="columnsVisible['totalsub'].display">
                            {{ isRounded ? addSpace(roundTwoDigits(item.sumSub, 2)) : addSpace(item.sumSub) }}
                        </td>

                        <td v-show="columnsVisible['totalpresta'].display">
                            {{ isRounded ? addSpace(roundTwoDigits(item.sumPresta, 2)) : addSpace(item.sumPresta) }}
                        </td>

                        <td v-show="columnsVisible['total'].display">
                            {{ isRounded ? addSpace(roundTwoDigits(item.sum, 2)) : addSpace(item.sum) }}
                        </td>

                        <td v-show="columnsVisible['totalProjet'].display">
                          {{ isRounded ? addSpace(roundTwoDigits(item.total, 2)) : addSpace(item.total) }}
                        </td>

                        <td></td>

                    </tr>

                </template>

            </b-table>

        </div>

        <!-- Max Allouable Detail -->
        <b-modal :active.sync="isFinanceurModalActive"
                 has-modal-card
                 full-screen>
          <DetailFinanceur
              :maxDetails="maxDetails">
          </DetailFinanceur>
        </b-modal>

        <b-modal :active.sync="isProjectModalActive"
                 has-modal-card
                 full-screen>
            <DetailProject
                :detailProject="detailProject">
            </DetailProject>
        </b-modal>

    </section>
</template>

<script>

import DetailProject from "./DetailProject";
import DetailFinanceur from "./DetailFinanceur";

export default {
    name: "TableFinanceur",
    components: {DetailProject, DetailFinanceur},
    mounted() {
        this.getFinanceurs();
        this.getFolders();
    },
    computed: {},
    methods: {
        getDetailFinanceur(row) {
          this.$axios.get(`max-allouable-detail?financeur=${row.financeurs}`)
          .then(function (response) {
            this.maxDetails  = { max: response.data.rows[0], conso: row }
            this.isFinanceurModalActive = true;
          }.bind(this))
          .catch(error => console.log(error));
        },
        getDetailProject(p) {
            this.$axios.get(`project-finance?project=${p}`)
                .then(function (response) {
                    this.detailProject = response.data[0];
                    this.isProjectModalActive = true;
                }.bind(this))
                .catch(error => console.log(error));
        },
        searchP() {
            this.filterR = '';
            this.data = this.dataOrigin;
            if (this.filterP.length > 1) {
                const reg = new RegExp(`${this.filterP}`, 'i');
                this.data = this.dataOrigin.filter(i => i.financeurs.match(reg));
            } else {
                this.data = this.dataOrigin;
            }
        },
        searchR() {
            // TODO : refaire ce truc de gitan
            this.filterP = '';
            if (this.filterR.length > 1) {
                this.data = [];
                let t = this.dataOrigin;
                const reg = new RegExp(`${this.filterR}`, 'i');
                t.forEach(p => {
                    let arr = p.details.filter(d => d.project.match(reg));
                    let tempP = p;
                    tempP.details = arr;
                    this.data.push(tempP)
                })
                this.data = this.data.filter(i => i.details.length > 0);
            } else if (this.filterR.length === 0) {
                this.getFinanceurs();
            }
        },
        filterByFolder(e) {
            if (e === 'all') {
                this.data = JSON.parse(JSON.stringify(this.dataOrigin));
            } else {
                this.data = [];
                let t = JSON.parse(JSON.stringify(this.dataOrigin));
                t.forEach(p => {
                    let arr = p.synth.filter(d => d.dossiers !== null ? d.dossiers.includes(e) : null);
                    let tempP = p;
                    tempP.synth = arr;
                    this.data.push(tempP)
                })
                this.data = this.data.filter(i => i.synth.length > 0);
            }
        },
        getFinanceurs() {
            const loadingComponent = this.$buefy.loading.open({
                container: null
            })
            this.$axios.get(`fi`) // TODO
                .then(function (response) {
                    this.data = response.data.f;
                    this.dataOrigin = response.data.f;
                    // Calcul sums
                    this.totalSub = this.addSpace(this.roundTwoDigits(this.data.reduce((acc, cur) => acc + Number(cur.sumsSub), 0), 2));
                    this.totalPresta = this.addSpace(this.roundTwoDigits(this.data.reduce((acc, cur) => acc + Number(cur.sumsPresta), 0), 2));
                    this.totalTotal = this.addSpace(this.roundTwoDigits(this.data.reduce((acc, cur) => acc + Number(cur.sums), 0), 2));

                    loadingComponent.close()
                }.bind(this))
                .catch(error => {
                    console.log(error);
                    loadingComponent.close();
                });
        },
        getFolders() {
            this.$axios.get(`ref/folders`)
                .then(function (response) {
                    this.folders = response.data.body.dossiers
                }.bind(this))
                .catch(error => {
                    console.log(error);
                });
        }
    },
    data() {
        return {
            data: [],
            dataOrigin: [],
            columnsVisible: {
                total: {title: 'Total sollicité (€)', display: true},
                totalProjet: {title: 'Total projet (€)', display: true},
                maxallouable: {title: 'Demandé / max allouable (€)', display: true},
                totalsub: {title: 'Total Subvention (€)', display: true},
                totalpresta: {title: 'Total Prestation (€)', display: true},
            },
            showDetailIcon: true,
            filterP: '',
            filterR: '',
            isRounded: true,
            detailProject: {},
            isProjectModalActive: false,
            isFinanceurModalActive: false,
            maxDetails: null,
            totalSub: 0,
            totalPresta: 0,
            totalTotal: 0,
        }
    }
}
</script>

<style scoped>

.container {
    max-width: 100%;
    padding-left: 5%;
    padding-right: 5%;
}

.pointer {
    cursor: pointer;
}

</style>
